import styled from "styled-components";
import { Button, Container, Modal } from "react-bootstrap";
import { colors, types, BaseButton } from "../../libs";

export const StyledContainer = styled(Container)`
    padding-top: 16px;
    max-width: 1111px;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeftSection = styled.div`
    ${types.headers.itemMedium};
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const HeaderTitle = styled.h2`
    ${types.headers.itemMedium};
    background: ${colors.text.textGradient};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0;
`;

export const HeaderRightSection = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const Description = styled.p`
    ${types.body.normal};
    color: ${colors.text.gray};
    margin-top: 8px;
    margin-bottom: 0;
`;

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 20px;
    flex-wrap: wrap;
`;

export const PrimaryButton = styled(BaseButton)`
    border-radius: 0;
    width: auto;
`;

export const ButtonContent = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    white-space: nowrap;
    font-size: 14px;
`;

export const ActionButton = styled(Button)`
    background: ${colors.background.lightBlack};
    color: ${colors.text.white};
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    white-space: nowrap;
    border: 1px solid rgba(255, 255, 255, 0.15);
    font-size: 14px;
    border-radius: 8px;
    &:hover {
        background: ${colors.background.lightGrey};
        color: ${colors.text.white};
    }
    &:focus,
    &:active {
        background: ${colors.background.lightGrey} !important;
        color: ${colors.text.white} !important;
    }
`;

export const DangerButton = styled(Button)`
    background: transparent;
    color: ${colors.text.error};
    padding: 6px 12px;
    border: 1px solid ${colors.text.error};
    font-size: 13px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 4px;
    &:hover {
        background: ${colors.background.error};
        color: ${colors.text.error};
        border-color: ${colors.text.error};
    }
    &:focus,
    &:active {
        background: ${colors.background.error} !important;
        color: ${colors.text.error} !important;
        border-color: ${colors.text.error} !important;
    }
`;

export const NewFolderForm = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 12px;
    padding: 12px 16px;
    background: ${colors.background.formField};
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
`;

export const NewFolderInput = styled.input`
    flex: 1;
    background: ${colors.background.smokyBlack};
    color: ${colors.text.white};
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    padding: 7px 14px;
    font-size: 14px;
    &:focus {
        outline: none;
        border-color: ${colors.background.green};
    }
    &::placeholder {
        color: ${colors.text.disabled};
    }
`;

export const Breadcrumb = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 20px;
    margin-bottom: 4px;
    flex-wrap: wrap;
`;

export const BreadcrumbItem = styled.span<{ $active?: boolean }>`
    ${types.body.normal};
    color: ${(props) => (props.$active ? colors.text.white : colors.text.gray)};
    cursor: ${(props) => (props.$active ? "default" : "pointer")};
    font-weight: ${(props) => (props.$active ? "600" : "400")};
    &:hover {
        color: ${(props) => (props.$active ? colors.text.white : colors.text.green)};
    }
`;

export const BreadcrumbSeparator = styled.span`
    color: ${colors.text.disabled};
    font-size: 12px;
`;

export const UploadProgressList = styled.div`
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const UploadProgressItem = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: ${colors.background.formField};
    border: 1px solid rgba(183, 248, 77, 0.2);
    border-radius: 8px;
`;

export const UploadProgressLabel = styled.span`
    ${types.body.normal};
    color: ${colors.text.white};
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const UploadProgressBarWrapper = styled.div`
    flex: 2;
    height: 6px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    overflow: hidden;
`;

export const UploadProgressBar = styled.div<{ $pct: number }>`
    height: 100%;
    width: ${(props) => props.$pct}%;
    background: ${colors.background.green};
    border-radius: 3px;
    transition: width 0.3s ease;
`;

export const UploadProgressPercent = styled.span`
    ${types.body.small};
    color: ${colors.text.green};
    min-width: 36px;
    text-align: right;
`;

export const ItemsList = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const FileCard = styled.div<{ $highlighted?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: ${(props) =>
        props.$highlighted ? "rgba(183, 248, 77, 0.06)" : colors.background.lightBlack};
    border: 1px solid ${(props) =>
        props.$highlighted ? "rgba(183, 248, 77, 0.55)" : "rgba(255, 255, 255, 0.07)"};
    border-radius: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease;
    &:hover {
        border-color: ${(props) =>
            props.$highlighted ? "rgba(183, 248, 77, 0.7)" : "rgba(183, 248, 77, 0.25)"};
    }
`;

export const FileCardLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1;
    min-width: 0;
`;

export const FileIcon = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: ${colors.background.formField};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
`;

export const FileInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const FileName = styled.div`
    ${types.body.normal};
    font-weight: 600;
    color: ${colors.text.white};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const FileNameLink = styled.a`
    ${types.body.normal};
    font-weight: 600;
    color: ${colors.text.white};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    text-decoration: none;
    &:hover {
        color: ${colors.text.green};
    }
`;

export const FileMeta = styled.div`
    ${types.body.small};
    color: ${colors.text.gray};
    margin-top: 3px;
`;

export const FileCardRight = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`;

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 24px;
    gap: 12px;
`;

export const EmptyStateIcon = styled.div`
    font-size: 48px;
    opacity: 0.4;
`;

export const EmptyStateText = styled.p`
    ${types.body.normal};
    color: ${colors.text.disabled};
    margin: 0;
`;

export const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px;
    color: ${colors.background.green};
    & > .spinner-border {
        width: 3rem;
        height: 3rem;
    }
`;

// Search modal

export const SearchModal = styled(Modal)`
    .modal-content {
        background: ${colors.background.formField};
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 14px;
    }
    .modal-header {
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        padding: 16px 20px;
    }
    .modal-title {
        ${types.headers.itemSmall};
        color: ${colors.text.white};
    }
    .btn-close {
        filter: invert(1) opacity(0.5);
        &:hover {
            filter: invert(1) opacity(1);
        }
    }
    .modal-body {
        padding: 20px;
    }
`;

export const ModalSearchWrapper = styled.div`
    position: relative;
    margin-bottom: 16px;
`;

export const ModalSearchIconWrapper = styled.span`
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: ${colors.text.disabled};
    display: flex;
    align-items: center;
`;

export const ModalSearchInput = styled.input`
    width: 100%;
    background: ${colors.background.smokyBlack};
    color: ${colors.text.white};
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    padding: 10px 16px 10px 42px;
    font-size: 14px;
    &:focus {
        outline: none;
        border-color: ${colors.background.green};
    }
    &::placeholder {
        color: ${colors.text.disabled};
    }
`;

export const ModalResultsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 400px;
    overflow-y: auto;
    padding-right: 2px;
    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.15);
        border-radius: 2px;
    }
`;

export const ModalResultItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 14px;
    background: ${colors.background.lightBlack};
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 10px;
`;

export const ModalResultLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
`;

export const ModalResultInfo = styled.div`
    flex: 1;
    min-width: 0;
`;

export const ModalResultName = styled.div`
    ${types.body.normal};
    font-weight: 600;
    color: ${colors.text.white};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const ModalResultMeta = styled.div`
    ${types.body.small};
    color: ${colors.text.gray};
    margin-top: 2px;
`;

export const ModalViewButton = styled(Button)`
    background: transparent;
    color: ${colors.text.green};
    border: 1px solid rgba(183, 248, 77, 0.4);
    font-size: 12px;
    padding: 5px 12px;
    border-radius: 6px;
    white-space: nowrap;
    flex-shrink: 0;
    &:hover {
        background: rgba(183, 248, 77, 0.1);
        color: ${colors.text.green};
        border-color: rgba(183, 248, 77, 0.7);
    }
    &:focus,
    &:active {
        background: rgba(183, 248, 77, 0.1) !important;
        color: ${colors.text.green} !important;
        border-color: rgba(183, 248, 77, 0.7) !important;
    }
`;

export const ModalEmptyText = styled.p`
    ${types.body.normal};
    color: ${colors.text.disabled};
    text-align: center;
    margin: 24px 0;
`;

export const ModalLoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding: 32px;
    color: ${colors.background.green};
`;

export const ShareButton = styled(Button)`
    background: transparent;
    color: ${colors.text.disabled};
    border: 1px solid rgba(255, 255, 255, 0.12);
    font-size: 13px;
    padding: 6px 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    &:hover {
        color: ${colors.text.green};
        border-color: rgba(183, 248, 77, 0.4);
        background: transparent;
    }
    &:focus,
    &:active {
        background: transparent !important;
        color: ${colors.text.green} !important;
        border-color: rgba(183, 248, 77, 0.4) !important;
    }
`;

export const ShareModal = styled(Modal)`
    .modal-content {
        background: ${colors.background.formField};
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 14px;
    }
    .modal-header {
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        padding: 16px 20px;
    }
    .modal-title {
        ${types.headers.itemSmall};
        color: ${colors.text.white};
    }
    .btn-close {
        filter: invert(1) opacity(0.5);
        &:hover { filter: invert(1) opacity(1); }
    }
    .modal-body {
        padding: 24px 20px;
    }
`;

export const ShareFileName = styled.p`
    ${types.body.normal};
    color: ${colors.text.gray};
    margin-bottom: 16px;
`;

export const ShareLinkRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ShareLinkInput = styled.input`
    flex: 1;
    background: ${colors.background.smokyBlack};
    color: ${colors.text.white};
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 0;
    padding: 9px 14px;
    font-size: 13px;
    outline: none;
    cursor: text;
`;

export const CopyButton = styled(Button)`
    background: ${colors.background.green};
    color: ${colors.text.black};
    border: none;
    border-radius: 0;
    padding: 9px 18px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    &:hover {
        background: ${colors.background.lightGreen};
        color: ${colors.text.black};
    }
    &:focus,
    &:active {
        background: ${colors.background.lightGreen} !important;
        color: ${colors.text.black} !important;
    }
`;

export const CopiedBadge = styled.span`
    ${types.body.small};
    color: ${colors.text.green};
    margin-top: 8px;
    display: block;
`;
